function replaceDiacritic(str) {
	return str.normalize('NFD').replace(/\p{Diacritic}/gu, '');
}

export default replaceDiacritic;
